import { render, staticRenderFns } from "./CampusCulture.vue?vue&type=template&id=c93d7344&scoped=true&"
import script from "./CampusCulture.vue?vue&type=script&lang=js&"
export * from "./CampusCulture.vue?vue&type=script&lang=js&"
import style0 from "./CampusCulture.vue?vue&type=style&index=0&id=c93d7344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93d7344",
  null
  
)

export default component.exports